import React, {useState} from "react";
import ArrayStore from "devextreme/data/array_store";
import List from "devextreme-react/list";
import {Layout, LayoutChild} from "../../../../palette/Palette";
import {FilterDelete} from "../../../../utils/HelpFunctions";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import Divider from '@material-ui/core/Divider';
import ExploreOffOutlinedIcon from '@material-ui/icons/ExploreOffOutlined';
import {useSnackbar} from "notistack";
import Text from "../../../../palette/Text";
import Dialog from "../../../../palette/Dialog";

function ZoneList(props) {

    const {data, setZones, docRef, city, setIdEdit, setEdit, setSliderValue, setRadius} = props

    const [openDialog, setOpenDialog] = useState(false)
    const [zoneID, setZoneID] = useState(null)
    const [load, setLoad] = useState(false)

    const {enqueueSnackbar} = useSnackbar();

    const dataSource = new ArrayStore({
        key: 'ID',
        data: data
    });

    const onEdit = (ID, radius) => {
        setEdit(true)
        setIdEdit(ID)
        setSliderValue({sliderValue: radius})
        setRadius(radius)
    }

    const openDialogPopup = (ID) => {
        setOpenDialog(true)
        setZoneID(ID)
    }

    const onDelete = async () => {
        setLoad(true)
        const resultDelete = FilterDelete(data, 'ID', zoneID)
        let id = 0
        const zoneList = [...resultDelete]
        zoneList.forEach(item => {
            id = id + 1
            item.ID = id
            item.zone = `Zona ${id}`
        })

        await docRef.doc(city).set({zoneList})
            .then(() => {
                NotiStackInfo('Los datos han sido eliminados exitosamente', 'success', enqueueSnackbar)
                setZones(zoneList)
                setLoad(false)
                setOpenDialog(false)
            }).catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                setLoad(false)
            })
    }

    function ItemTemplate(data) {
        return (
            <div>
                {data !== undefined &&
                <Layout row center space>
                    <LayoutChild row center>
                        <LayoutChild center>
                            <ExploreOffOutlinedIcon style={{color: '#ff8a65'}}/>
                        </LayoutChild>
                        <LayoutChild left={10}>
                            <Text hover={false} color={'#333'} weight={'800'} text={data.zone} size={14}/>
                            <Text hover={false} color={'gray'} weight={'500'} text={`${data.radius} km`} size={11}/>
                        </LayoutChild>

                    </LayoutChild>
                    <LayoutChild color={'transparent'} width={'auto'} row center>
                        <i style={styles.editIcon} className="far fa-edit"
                           onClick={() => onEdit(data.ID, data.radius)}/>
                        <i style={styles.deleteIcon} className="far fa-trash-alt"
                           onClick={() => openDialogPopup(data.ID)}/>
                    </LayoutChild>
                </Layout>}
            </div>
        )
    }

    return (
        <>
            <div className="list-container-prz">
                <LayoutChild width="100%" center padding={10}>
                    <Text hover={false} text={'Zonas restringidas'} size={15} color="#1A5487" weight={'900'}/>
                </LayoutChild>
                <Dialog title="Eliminar zona" text={'Esta seguro que desea eliminar esta zona ?'} onClick={onDelete}
                        openDialog={openDialog} setOpenDialog={setOpenDialog} textButton={'Eliminar zona'} load={load}/>
                <Divider/>
                <Layout color={'transparent'}>
                    <List
                        dataSource={dataSource}
                        height={'auto'}
                        itemRender={ItemTemplate}
                        showSelectionControls={true}
                    />
                    <div style={{height: 80}}/>
                </Layout>
            </div>
        </>
    )
}

export default ZoneList

const styles = {
    editIcon: {
        color: '#607d8b',
        fontSize: 24,
        marginRight: 15
    },
    deleteIcon: {
        color: '#f44336',
        fontSize: 24,
    }
}